import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  hasUserAccess,
  getUserDetails,
  getUserRole,
} from "../../../../backend/auth";
import {
  DEFAULT_OPTIONS_PAYLOAD,
  DEFAULT_PAYLOAD,
} from "../../../common/Table";
import {
  useGetCompanies,
  useGetCompanyLocations,
  useGetCompanyVendorLocations,
  useGetUserVendorsCompanies,
  useGetVendor,
  useGetVendorAssociateCompanies,
  useGetVendorCategories,
  useGetVendorCategoriresCompanies,
  useGetVendorCompanies,
  useGetVendorLocations,
} from "../../../../backend/masters";

function AdminVendorLocations({ onChange }: any) {
  const _role = getUserRole();
  const [t] = useState(new Date().getTime());
  const [company, setCompany] = useState<any>(null);
  const [associate_company, setAssociateCompany] = useState<any>(null);
  const [location, setLocation] = useState<any>(null);
  const [vendorCategoriesId, setVendorCategoriesId] = useState<any>(null);
  const [vendorRegistrationId, setVendorRegistrationId] = useState<any>(null);
  const { companies: parentCompanies, isFetching: fetchingCompanies } =
    useGetCompanies({
      ...DEFAULT_OPTIONS_PAYLOAD,
      filters: { is_parent_eq: true }
    });
  const {
    companies: associateCompanies,
    isFetching: fetchingAssociateCompanies,
  } = useGetCompanies(
    {
      ...DEFAULT_OPTIONS_PAYLOAD,
      filters: {
          is_parent_eq: 'false',
          parent_company_id_eq: (company || {}).value
      }
    },
    Boolean((company || {}).value)
  );
  const { vendorCategories, isFetching: fetchingVendorCategories } =
    useGetVendorCategories({
      ...DEFAULT_OPTIONS_PAYLOAD
    });

  const {
    locations,
    isFetching: fetchinglocation,
    refetch: locationRefetch,
  } = useGetCompanyLocations(
    {
      ...DEFAULT_OPTIONS_PAYLOAD,
      includes: ['location'],
      include: ['location'],
      filters: {
          company_id_eq: (associate_company || {}).value
      }
    },
    Boolean(associate_company)
  );
  const {
    vendorLocations,
    isFetching,
    refetch: vendorMappingRefetch,
  } = useGetCompanyVendorLocations(
    {
      filters: {
        associate_company_id_eq: (associate_company || {}).value,
        location_id_eq: (location || {}).value,
        vendor_category_id_eq: vendorCategoriesId ? vendorCategoriesId.value : "",
      },
      include: ["vendor_registration"],
      includes: ['vendor_registration']
    },
    Boolean(associate_company && location)
  );

  useEffect(() => {
    if (company) {
      setAssociateCompany(undefined);
      setLocation(undefined);
      setVendorCategoriesId(undefined);
      setVendorRegistrationId(undefined);
    }
  }, [company]);


  const handleChangeCompany = (selectedCompany: any) => {
    setCompany(selectedCompany);
    setVendorCategoriesId(null);
    setVendorRegistrationId( null); 
  };
  const handleChangeAssocaiteCompany = (selectedCompany: any) => {
    setAssociateCompany(selectedCompany);
    setVendorCategoriesId(null);
    setVendorRegistrationId( null);
  };
  const handleChangeLocation = (selectedCompany: any) => {
    setLocation(selectedCompany);
    setVendorCategoriesId(null);
    setVendorRegistrationId( null);
  };
  const handleChangeVendorCategories = (selectedCategory: any) => {
    setVendorCategoriesId(selectedCategory);
    setVendorRegistrationId(undefined);
  };

  useEffect(() => {
    if (associate_company) {
      setLocation(undefined);
      setVendorCategoriesId(undefined);
      setVendorRegistrationId(undefined);
      vendorMappingRefetch();
    }
  }, [associate_company]);

  useEffect(() => {
    if (
      company &&
      associate_company &&
      location &&
      vendorCategoriesId &&
      vendorRegistrationId
    ) {
      onChange({
        company: company.value,
        associate_company: associate_company.value,
        location_id: location.value,
        vendor_category_id: vendorCategoriesId.value,
        vendor_registration_id: vendorRegistrationId.value,
      });
    }
  }, [vendorRegistrationId]);

  useEffect(() => {
    if (
      company &&
      associate_company &&
      location &&
      vendorCategoriesId 
    ) {
      onChange({
        company: company.value,
        associate_company: associate_company.value,
        location_id: location.value,
        vendor_category_id: vendorCategoriesId.value,
        vendor_registration_id: null,
      });
    }
  }, [vendorCategoriesId]);
  
  useEffect(() => {
    if (
      company &&
      associate_company &&
      location 
    ) {
      onChange({
        company: company.value,
        associate_company: associate_company.value,
        location_id: location.value,
        vendor_category_id: null,
        vendor_registration_id: null,
      });
    }
  }, [location]);
  useEffect(() => {
    if (
      company &&
      associate_company 
    ) {
      onChange({
        company: company.value,
        associate_company: associate_company.value,
        location_id: null,
        vendor_category_id: null,
        vendor_registration_id: null,
      });
    }
  }, [associate_company]);

  useEffect(() => {
    if (!fetchingCompanies && parentCompanies) {
      const _parentCompany = parentCompanies[0];
      if (_parentCompany) {
        setCompany({ value: _parentCompany.id, label: _parentCompany.name });
        vendorMappingRefetch();
      }

    }
  }, [fetchingCompanies]);

  useEffect(() => {
    if (!fetchingAssociateCompanies && associateCompanies) {
      const _associate_company = associateCompanies[0];
      if (_associate_company) {
        setAssociateCompany({
          value: _associate_company.id,
          label: _associate_company.name,
        });
        vendorMappingRefetch();
      }
    }
  }, [fetchingAssociateCompanies]);

  useEffect(() => {
    if (!fetchingVendorCategories && vendorCategories) {
      const _category = vendorCategories[0];
      if (_category) {
        setVendorCategoriesId({
          value: _category.id,
          label: _category.vendorCategoryName,
        });
      }
      vendorMappingRefetch();
    }
  }, [fetchingVendorCategories]);

  useEffect(() => {
    if (!isFetching && vendorLocations) {
      const _vendor = vendorLocations[0];
      if (_vendor && _vendor.vendorRegistration !== undefined) {
        const vendorRegistration = _vendor.vendorRegistration;
        setVendorRegistrationId({
          value: _vendor.vendorRegistrationId || "",
          label: vendorRegistration.vendorName || "",
        });
      }
    }
  }, [isFetching]);

  useEffect(() => {
    vendorMappingRefetch();
  }, [location]);

  useEffect(() => {
    if (!fetchinglocation && locations) {
      const _location = locations[0];
      if (_location) {
        setLocation({
          value: _location.location.id,
          label: _location.location.name,
        });
      }
    }
  }, [fetchinglocation]);
  

  return (
    <>
      <div className="px-2">
        <label className="filter-label">
          <small>Company</small>
        </label>
        <Select
          placeholder="Company"
          options={(parentCompanies || []).map((x: any) => ({
             value: x.id, label: x.name 
          }))}
          onChange={handleChangeCompany}
          value={company}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Associate Company</small>
        </label>
        <Select
          placeholder="Associate Company"
          options={
            Array.isArray(associateCompanies)
              ? associateCompanies.map((x: any) => ({
                  value: x.id,
                  label: x.name,
                }))
              : []
          }
          onChange={handleChangeAssocaiteCompany}
          value={associate_company}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Location</small>
        </label>
        <Select
          placeholder="Location"
          options={
            Array.isArray(locations)
              ? locations.map(({ location }: any) => ({
                  value: location.id,
                  label: location.name,
                }))
              : []
          }
          onChange={handleChangeLocation}
          value={location || null}
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor Category</small>
        </label>
        <Select
          placeholder="Category"
          options={(vendorCategories || []).map((x: any) => ({
             value: x.id, label: x.name 
          }))}
          onChange={(e) => {
            handleChangeVendorCategories(e);
          }}
          value={vendorCategoriesId || null} 
          className="select-control"
        />
      </div>
      <div className="px-2">
        <label className="filter-label">
          <small>Vendor</small>
        </label>
        <Select
          placeholder="Vendors"
          options={
            Array.isArray(vendorLocations)
              ? vendorLocations.map((x: any) => {
                return {
                  value: (x.vendor_registration || {}).id,
                  label: (x.vendor_registration || {}).vendor_name,
                }})
              : []
          }
          onChange={setVendorRegistrationId}
          value={vendorRegistrationId || null}
          className="select-control"
        />
      </div>
    </>
  );
}

export default AdminVendorLocations;
